import {
  acceptOnlyFilterdKeys,
  basePathRewrite,
  closeFJDifferentModal,
  commonPropsForSSR,
  getEJendPoints,
  getURLSearchParams,
  logApiResponseTime,
  makeFlexJobsWizardBoolean,
  modifyJobFilters,
  readCookie,
} from '@components/common';
import { _CONSTANTS, remoteJobsList } from '@components/common/constant';
import {
  getFilterQueryString,
  mapQueryParams,
} from '@components/common/filterHelper';
import FlexJobDifferModal from '@components/companies/unAuthPopup';
import { RemoteCategoriesMetaTags } from '@components/metaComponent/remoteCategories';
import SearchListingContainer from '@components/searchListContainer';
import { cdnEXPTType, IDeviceType, IJobCount } from '@components/shared.types';
import { JobLinks, socialLinks } from '@components/wlb/constant';
import { JobCategoryList, JobSearchSteps } from '@license-admin/boldjobs';
import { fireExperimentEvent } from '@utils/cdnTracking';
import jobSearchStepsProps from '@utils/jobSearchStepsProps';
import softRegModalProps from '@utils/softRegModalProps';
import {
  getJobDetails,
  getJobDetailsApiUrl,
  getLocalizationAndConfig,
  modifyJobDetails,
} from 'API/jobs';
import { apiCallList } from 'API/wlb/ApiClient';
import { getJobsByCategory } from 'API/wlb/jobs';
import {
  getBackendVisiterExpDetail,
  getCDNExptDetails,
} from 'helper/experiments/experimentActions';
import { RMCPortalExperiments } from 'helper/experiments/experimentConstants';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import Head from 'next/head';
import Script from 'next/script';
import { useEffect, useState } from 'react';

type IProps = {
  localization: any;
  isPremiumUser: boolean;
  deviceType: IDeviceType;
  themeType?: string;
  selectedFilters: { [key: string]: Array<string> };
  categorizedJobs: any;
  jobCardData: any;
  queryParams: any;
  config: any;
  isMobileView: boolean;
  isLoggedIn: boolean;
  isFromWizardPage: boolean;
  hiring_count: IJobCount;
  breadCrumbProps: {
    breadCrumbName: string;
    breadCrumbNameValue: string[];
    isRemoteJobsPage: boolean;
    breadCrumbsData: {
      page: string;
      title: string;
      children: {
        name: string;
        path: string;
        static: boolean;
      }[];
    };
  };
  cdnExptData?: cdnEXPTType;
  referer: string;
  isSearchPage?: boolean;
  cookies?: any;
  localizationWhyRMCJobs?: any;
  jobDetailsApiUrl?: any;
  userAgent: string;
};

export default function WhiteLabelRJobs(props: IProps) {
  const {
    config,
    localization,
    themeType,
    jobCardData,
    isMobileView,
    isLoggedIn,
    isFromWizardPage,
    cdnExptData,
    localizationWhyRMCJobs,
    jobDetailsApiUrl,
    userAgent,
  } = props;
  const [showFlexJobsDifferent, setShowFlexJobsDifferent] = useState(false);
  const [isSoftRegModal, setIsSoftRegModal] = useState(false);
  const [isAddStaticSearchList, setAddStaticSearchList] =
    useState<boolean>(false);
  const [isSoftRegAlreadyShown, setIsSoftRegAlreadyShown] = useState(
    !!readCookie('softRegPopupDisplayed')
  );
  // const [shouldShowDrawer, setShouldShowDrawer] = useState(!isLoggedIn);

  let softRegPopupTimout: any = null;
  useEffect(() => {
    if (isFromWizardPage) {
      clearTimeout(softRegPopupTimout);
      softRegPopupTimout = setTimeout(() => {
        setIsSoftRegModal(true);
      }, 4000);
    }

    setShowFlexJobsDifferent(
      makeFlexJobsWizardBoolean(
        props.referer,
        props.isPremiumUser,
        props.isSearchPage
      )
    );
  }, []);
  // const mobileView = props.deviceType === 'mobile';
  // useEffect(() => {
  //   const popUpCount = getDrawerPopCount();
  //   if (popUpCount) {
  //     popUpCount >= 4 && setShouldShowDrawer(false);
  //   }
  //   // show mobile pop up after given time //
  //   const time = setTimeout(async () => {
  //     if (mobileView && !isSoftRegAlreadyShown) {
  //       console.log('softRegAlreadyShown-->', isSoftRegAlreadyShown);

  //       setIsSoftRegModal(true);
  //     }
  //   }, 15000);

  //   return () => clearTimeout(time);
  // }, [mobileView]);

  useEffect(() => {
    if (jobDetailsApiUrl) {
      console.log('jobDetailsApiUrl-->', jobDetailsApiUrl);
    }
  }, []);
  useEffect(() => {
    const conductExperiment = async () => {
      const visitorId = readCookie(_CONSTANTS.VSTR);
      if (visitorId) {
        const experimentData = await getBackendVisiterExpDetail(
          props.deviceType,
          {
            mobile: RMCPortalExperiments.rmcLocationFieldMobile,
            desktop: RMCPortalExperiments.rmcLocationFieldDesktop,
          },
          userAgent
        );
        if (experimentData?.variant && experimentData?.variant > 2) {
          setAddStaticSearchList(true);
        }
      } else {
        setTimeout(conductExperiment, 500);
      }
    };

    const timeoutId = setTimeout(conductExperiment, 500);

    return () => clearTimeout(timeoutId);
  }, []);
  const breadCrumbProps = {
    breadCrumbName: `${
      props.isPremiumUser ? 'rmc-remote-jobs-auth' : 'rmc-remote-jobs-unauth'
    }`,
    breadCrumbNameValue: [''],
    isRemoteJobsPage: true,
    breadCrumbsData: [
      {
        page: 'rmc-remote-jobs-auth',
        title: 'Remote Jobs - No Ads, Scams, or Junk',
        children: [
          {
            name: 'My Dashboard',
            path: '/dashboard',
            static: false,
          },
          {
            name: 'Remote Jobs',
            path: '/remote-jobs',
            static: false,
          },
        ],
      },
      {
        page: 'rmc-remote-jobs-unauth',
        title: 'Remote Jobs - No Ads, Scams, or Junk',
        children: [
          {
            name: 'Home',
            path: '/',
            static: false,
          },
          {
            name: 'Remote Jobs',
            path: '/remote-jobs',
            static: false,
          },
        ],
      },
    ],
  };

  const searchForm = (
    <SearchListingContainer
      localization={localization}
      deviceType={props.deviceType}
      isPremiumUser={false}
      jobsData={jobCardData}
      queryParams={props.queryParams}
      jobFilters={jobCardData.jobFilters}
      selectedFilters={props.selectedFilters}
      isRemoteJobsPage={true}
      envPath={process.env.NEXT_PUBLIC_ROOT_URL}
      isAddStaticSearchList={isAddStaticSearchList}
      isExperiment={
        cdnExptData &&
        cdnExptData?.vID == '3' &&
        isLoggedIn &&
        !props.isPremiumUser
      }
    />
  );

  const softRegProps = softRegModalProps({
    config,
    jobCardData,
    isFromWizardPage,
    isMobileView: props.deviceType === 'mobile',
    hiring_count: props.hiring_count,
    isExperiment:
      cdnExptData && cdnExptData?.vID == '3' && !props.isPremiumUser,
  });
  const jobSearchStepsProp = jobSearchStepsProps({
    isCloseAllowed: true,
    isLoggedIn: isLoggedIn,
    themeType: themeType,
    isCategoryPage: false,
    signupAndFind: localization.unlock_banner.signup_and_find,
    jobsData: jobCardData,
    categoryDetails: {},
    hiringCount: props.hiring_count,
    localization: localization,
    screenName: 'jobs by category',
  });

  return (
    <>
      <Head>
        {RemoteCategoriesMetaTags({ categoryName: 'index' })}
        {!isLoggedIn && isSoftRegModal && !isSoftRegAlreadyShown && (
          <link
            rel="prefetch"
            href="/payment/scripts/rmc/sellPrefetchScript.js"
            as="script"
          />
        )}
      </Head>
      <Script
        src="/ui-experimentation/cdn/experiment-sync.min.js"
        strategy="afterInteractive"
      />
      <Script id="experiment-script" strategy="afterInteractive">
        {`
          window.fireExperimentEvent = ${fireExperimentEvent.toString()};
        `}
      </Script>
      {!isFromWizardPage && showFlexJobsDifferent && (
        <FlexJobDifferModal
          closeModal={() => closeFJDifferentModal(setShowFlexJobsDifferent)}
          localizeflexjobPopup={localizationWhyRMCJobs}
        />
      )}
      <JobSearchSteps jobSearchStepsProps={jobSearchStepsProp} />
      <JobCategoryList
        isSoftRegModal={!isLoggedIn}
        softRegModalProps={softRegProps}
        breadCrumbProps={breadCrumbProps}
        pageHeading="Remote Jobs"
        deviceType={props.deviceType}
        themeType={themeType}
        categoryData={props.categorizedJobs}
        jobLinks={JobLinks}
        socialLinks={socialLinks}
        searchForm={searchForm}
        isCategoryListPage={true}
        isLoggedIn={isLoggedIn}
        basePathRewrite={basePathRewrite}
        localization={localization}
        jobDescriptionPara={localization.remoteJobDescription}
        envPath={process.env.NEXT_PUBLIC_ROOT_URL}
        isExperiment={
          cdnExptData && cdnExptData?.vID == '3' && !props.isPremiumUser
        }
        // dontShowSoftReg={shouldShowDrawer}
      />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext,
  resolvedUrl = ''
) => {
  let { req, query } = context;
  let jobCardData: any = [];
  let categorizedJobs: any = [];
  const isSearchPage = resolvedUrl?.includes('searchPage');
  const commonSSRProps = await commonPropsForSSR(
    req,
    isSearchPage ? 'simple-search' : 'jobs_page'
  );
  const { cookieHeader, cookies, isPremiumUser } = commonSSRProps;
  let selectedFilters = acceptOnlyFilterdKeys(query);
  query = mapQueryParams(query);
  let queryString: string = getFilterQueryString(query);
  let sortByPostedDate = false;
  let searchKeyword: string = getURLSearchParams(queryString, 'searchkeyword');
  const previousUrl = req.headers.referer || '/';
  const isFromWizardPage =
    previousUrl?.includes('job_wizard') || previousUrl?.includes('wizard');

  const ejEndPoints = getEJendPoints();

  const apiEndpoints = {
    job_details: { ...ejEndPoints.job_details, callback: modifyJobFilters },
    hiring_count: ejEndPoints.hiring_count,
  };

  await modifyJobDetails(
    apiEndpoints.job_details,
    `search/${queryString.slice(0, -1)}`,
    {
      sortByPostedDate: true,
      Age: 14,
    }
  );

  categorizedJobs = await getJobsByCategory(
    { size: '3', cookieHeader, req },
    remoteJobsList
  );

  const data = await apiCallList({ apiEndpoints, cookieHeader, req });
  let { job_details, hiring_count = { jobsCount: 0, companiesCount: 0 } } =
    data;

  let result = await apiEndpoints.job_details.callback(
    query,
    job_details,
    isPremiumUser
  );

  query = result.query;
  jobCardData = result.jobCardData;
  const localizationGenereicData = [getLocalizationAndConfig('*')];
  const [[localizationGenereic]] = await Promise.all<any>(
    localizationGenereicData
  );

  if (!searchKeyword) {
    sortByPostedDate = true;
  }
  const searchPromise = getJobDetails(
    `search${queryString.slice(0, -1)}`,
    cookieHeader,
    sortByPostedDate,
    !isSearchPage,
    req.headers
  );
  const searchWrapperPromise = logApiResponseTime(searchPromise, 'search');

  let jobDetailsApiUrl = '';
  if (query.debug) {
    jobDetailsApiUrl = getJobDetailsApiUrl(
      `search${queryString.slice(0, -1)}`,
      cookieHeader,
      sortByPostedDate,
      !isSearchPage,
      req.headers
    );
  }
  return {
    props: {
      ...commonSSRProps,
      fullwidth: true,
      jobCardData: jobCardData,
      categorizedJobs: categorizedJobs,
      selectedFilters,
      hiring_count,
      queryParams: query,
      isFromWizardPage,
      referer: req?.headers?.referer ?? '',
      userAgent: req?.headers['user-agent'] ?? '',
      jobDetailsApiUrl: jobDetailsApiUrl,
      isSearchPage: isSearchPage,
      localizationWhyRMCJobs: localizationGenereic['how_flexjob_different'],
      showAllDropFilters:
        cookies[_CONSTANTS.SET_SHOW_ALL_DROP_FILTERS] === 'true' ? true : false,
      cdnExptData: getCDNExptDetails(
        query,
        commonSSRProps.deviceType,
        commonSSRProps?.cookieHeader
      ),
    },
  };
};
